import React, { forwardRef, useImperativeHandle, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "animate.css";

const LikertImage = forwardRef((props, ref) => {
  const [selectedAnswer, setSelectedAnswer] = useState(props.q.answer || null); // Store selected answer
  const [textAnimationClassName, setTextAnimationClassName] = useState(props.textEntryAnimation);
  const [answersAnimationClassName, setAnswersAnimationClassName] = useState(props.answersEntryAnimation);

  function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  let ExitAnimation = async (goingTo, isNextDifferent, isPreviousDifferent) => {
    if (goingTo === "next") {
      if (isNextDifferent) {
        setTextAnimationClassName("animate__fadeOutUp");
        setAnswersAnimationClassName("animate__fadeOutDown");
      } else {
        setTextAnimationClassName("animate__backOutLeft");
        setAnswersAnimationClassName("temp");
      }
    }

    if (goingTo === "previous") {
      if (isPreviousDifferent) {
        setTextAnimationClassName("animate__fadeOutUp");
        setAnswersAnimationClassName("animate__fadeOutDown");
      } else {
        setTextAnimationClassName("animate__backOutRight");
        setAnswersAnimationClassName("temp");
      }
    }

    await timeout(400);
  };

  useImperativeHandle(ref, () => ({
    ExitAnimation, // exposing this function
  }));

  let HandleAnswering = async (a) => {
    setSelectedAnswer(a); // Update selected answer in state

    await props.SetAnswer(props.q.order, a, props.n + 1);
  };

  let HandleAnswerButtonClass = (no) => {
    return `answering-button  ${selectedAnswer === no && " selected"}  `;
  };

  return (
    <>
      <div className="question-text-segment text-container animate__animated  animate__faster">
        <h2
          className={` animate__animated  animate__faster ${textAnimationClassName} text-color-gray-dark `}
          id="question-text"
        >
          {props.q.text}
        </h2>
      </div>

      <Container className={`animate__animated   animate__faster ${answersAnimationClassName}`}>
        {props.a &&
          props.a.map((a, i) => {
            return (
              <Row className="justify-content-center" style={{ margin: "5px", width: "100%" }} key={i}>
                <Col xs="10" md="8" lg="4">
                  <button id={i + 1} className={HandleAnswerButtonClass(i + 1)} onClick={() => HandleAnswering(i + 1)}>
                    <span style={{ float: "left" }}>{i + 1}</span> {a}
                  </button>
                </Col>
              </Row>
            );
          })}
      </Container>
    </>
  );
});

export default LikertImage;
